import {
  AdvancedSettingsPanel,
  BothVisibilitySelects,
  Labels,
} from 'apps/studio/components/settings/fields/Base/advanced'

export const AdvancedPanel = AdvancedSettingsPanel([
  ...BothVisibilitySelects,
  ...Labels,
])
